import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LoggerService, Occ, OccEndpointsService, normalizeHttpError } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { InstallmentPayments } from '../../model/gg-payment.model';
import { PaymentAdapter } from './payment.adapter';
import { RedirectURL } from './payment.connector';
import { normalizePaymentHttpError } from '../../../util/normalize-payment-error';

@Injectable({
  providedIn: 'root',
})
export class OccPaymentAdapter implements PaymentAdapter {
  protected logger = inject(LoggerService);

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  addSelected(userId: string, cartId: string, selectedPayment: string): Observable<Occ.PaymentDetails> {
    const url = this.occEndpoints.buildUrl('addSelectedPayment', {
      urlParams: { userId, cartId, selectedPayment },
    });

    return this.http
      .post<Occ.PaymentDetails>(url, null)
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }

  getSelected(userId: string, cartId: string): Observable<string> {
    const url = this.occEndpoints.buildUrl('getSelectedPayment', { urlParams: { userId, cartId } });
    return this.http
      .get(url, { responseType: 'text' })
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }

  nestpayAuthorization(userId: string, cartId: string): Observable<string> {
    const url = this.occEndpoints.buildUrl('nestpayAuthorization', {
      urlParams: { userId, cartId },
    });

    return this.http
      .get(url, { responseType: 'text' })
      .pipe(catchError((error) => throwError(normalizePaymentHttpError(error, this.logger))));
  }

  klarna(userId: string, cartId: string): Observable<string> {
    const url = this.occEndpoints.buildUrl('klarna', {
      urlParams: { userId, cartId },
    });

    return this.http
      .post(url, null, { responseType: 'text' })
      .pipe(catchError((error) => throwError(normalizePaymentHttpError(error, this.logger))));
  }

  megapos(userId: string, cartId: string): Observable<string> {
    const url = this.occEndpoints.buildUrl('megapos', {
      urlParams: { userId, cartId },
    });

    return this.http
      .post(url, null, { responseType: 'text' })
      .pipe(catchError((error) => throwError(normalizePaymentHttpError(error, this.logger))));
  }

  stripe(userId: string, cartId: string): Observable<string> {
    const url = this.occEndpoints.buildUrl('stripe', {
      urlParams: { userId, cartId },
    });

    return this.http
      .post(url, null, { responseType: 'text' })
      .pipe(catchError((error) => throwError(normalizePaymentHttpError(error, this.logger))));
  }

  monri(userId: string, cartId: string): Observable<string> {
    const url = this.occEndpoints.buildUrl('monri', {
      urlParams: { userId, cartId },
    });

    return this.http
      .post(url, null, { responseType: 'text' })
      .pipe(catchError((error) => throwError(normalizePaymentHttpError(error, this.logger))));
  }

  simplepay(userId: string, cartId: string): Observable<string> {
    const url = this.occEndpoints.buildUrl('simplepay', {
      urlParams: { userId, cartId },
    });

    return this.http
      .post(url, null, { responseType: 'text' })
      .pipe(catchError((error) => throwError(normalizePaymentHttpError(error, this.logger))));
  }

  gpwebpay(userId: string, cartId: string): Observable<RedirectURL> {
    const url = this.occEndpoints.buildUrl('gpwebpay', {
      urlParams: { userId, cartId },
    });

    return this.http
      .post<RedirectURL>(url, null)
      .pipe(catchError((error) => throwError(() => normalizePaymentHttpError(error, this.logger))));
  }

  leanpay(userId: string, cartId: string): Observable<string> {
    const url = this.occEndpoints.buildUrl('leanpay', {
      urlParams: { userId, cartId },
    });

    return this.http
      .post(url, null, { responseType: 'text' })
      .pipe(catchError((error) => throwError(normalizePaymentHttpError(error, this.logger))));
  }

  payway(userId: string, cartId: string): Observable<string> {
    const url = this.occEndpoints.buildUrl('payway', {
      urlParams: { userId, cartId },
    });

    return this.http
      .post(url, null, { responseType: 'text' })
      .pipe(catchError((error) => throwError(normalizePaymentHttpError(error, this.logger))));
  }

  getInstallmentPayments(paymentMethod: string, price: number): Observable<InstallmentPayments> {
    const url = this.occEndpoints.buildUrl('installmentPayments', {
      urlParams: { paymentMethod, price },
    });
    return this.http
      .get<InstallmentPayments>(url)
      .pipe(catchError((error) => throwError(normalizePaymentHttpError(error, this.logger))));
  }

  paypal(userId: string, cartId: string): Observable<string> {
    const url = this.occEndpoints.buildUrl('paypal', {
      urlParams: { userId, cartId },
    });

    return this.http
      .post(url, null, { responseType: 'text' })
      .pipe(catchError((error) => throwError(normalizePaymentHttpError(error, this.logger))));
  }
}
